import type React from "react";
import { ClipboardList } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { isBusinessReportOutcome, type BusinessReportOutcomeDetails } from "@/modules/snapshots/businessReports.types";

interface Props {
  businessReportOutcome: BusinessReportOutcomeDetails | null;
}

export const BusinessReportOutcomeHeader: React.FC<Props> = ({ businessReportOutcome }) => {
  const documentName = businessReportOutcome?.fs_entry?.document_name || businessReportOutcome?.name;

  return (
    <div className="flex min-w-0 items-start gap-4">
      <span className="flex size-11 flex-shrink-0 items-center justify-center rounded-md bg-[#07142d] text-white">
        <ClipboardList className="size-5" aria-hidden="true" />
      </span>
      <div className="min-w-0">
        <div className="flex flex-wrap items-center gap-3">
          <h1 className="truncate text-3xl font-bold leading-tight text-[#111b35]">
            {businessReportOutcome?.business_report.name || "SnapShot"}
          </h1>
          {/* Single snapshots show verification on the Verify button; collection reports have no button. */}
          {isBusinessReportOutcome(businessReportOutcome) && businessReportOutcome?.verified && (
            <Badge variant="traffic-green">Verified</Badge>
          )}
        </div>
        {documentName && <p className="mt-1 truncate text-sm font-medium text-gray-500">{documentName}</p>}
      </div>
    </div>
  );
};
